import { fromEvent, Observable } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

/**
 * Observable Drag. Return relative position without the first
 * container, or body, with position non static.
 */
export function dragObservable(
  mousedownEvent: MouseEvent,
  doc: Document = document,
  container: HTMLElement | null = null,
): Observable<number> {
  if (!container) {
    container = mousedownEvent.target as HTMLElement;
    while (
      container.tagName !== 'BODY' &&
      getComputedStyle(container).getPropertyValue('position') !== 'static'
    ) {
      container = container.parentElement as HTMLElement;
    }
  }

  const { left, width } = container.getBoundingClientRect();
  const offsetX = mousedownEvent.offsetX;
  const mouseup = fromEvent<MouseEvent>(doc, 'mouseup');
  const mousemove = fromEvent<MouseEvent>(doc, 'mousemove');

  return mousemove.pipe(
    map(mousemoveEvent => {
      mousemoveEvent.preventDefault();
      return Math.min(
        1,
        Math.max(0, (mousemoveEvent.clientX - offsetX - left) / width),
      );
    }),
    takeUntil(mouseup),
  );
}
